import React, { Component } from 'react'

import NotificationSystem from "react-notification-system";
// style for notifications
import { style } from "variables/Variables.jsx";

import { connect } from 'react-redux'

class Notifications extends Component {

    constructor(props) {
        super(props);
        this.state = {
            _notificationSystem: null
        };
    }

    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
    }

    componentWillUpdate(nextProps) {
        if (nextProps.message !== this.props.message) {
            this.showNotification(nextProps.message.text, "tr", nextProps.message.type, nextProps.message.icon);
        }
    }

    showNotification(message, position, level, iconClass) {
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className={iconClass} />,
            message: (
                <div>
                    {message}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 15
        });
    }

    render() {
        return (
            <div>
                <NotificationSystem ref="notificationSystem" style={style} />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        message: state.application.message
    };
}

export default connect(mapStateToProps, null)(Notifications);



// WEBPACK FOOTER //
// ./src/components/Notifications/Notifications.jsx